export default "__VITE_ASSET__CyzDJfOq__"